






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CetakLabelKantongDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  readonly maksLabel = 50;

  jumlah: number | string | null = null;

  get kosong(): boolean {
    return this.jumlah === null || this.jumlah === "";
  }

  get jumlahValid(): boolean {
    const n = Number(this.jumlah);
    return !this.kosong && Number.isInteger(n) && n >= 1 && n <= this.maksLabel;
  }

  get pesanJumlah(): string {
    if (this.kosong || this.jumlahValid) return "";
    return Number(this.jumlah) > this.maksLabel ? `Maksimal ${this.maksLabel} label` : "Minimal 1 label";
  }

  @Watch("value")
  onBuka(val: boolean) {
    if (val) this.jumlah = null;
  }

  cetak() {
    if (!this.jumlahValid) return;
    this.$emit("cetak", Number(this.jumlah));
    this.$emit("input", false);
  }
}
